import * as React from 'react';
import Timeframe from '../Controls/Timeframe/Timeframe';
import OnboardNote from '../OnboardNote/OnboardNote';
import Why from './Why';
import timeframeIllustration from '../../assets/images/timeframe-illustration.svg';

interface WalkthroughTimeframeProps {
  duration: number;
  setDuration: (x: number) => object;
  next: () => void
  previous: () => void
  skip: () => void
}

const truncated = () => (
  <div>
    <h2>What are you saving for?</h2>
    <p>There are many goals that you might be working towards and it's important to keep those in mind when picking the timeframe for your investment.</p>
  </div>
);
const expanded = () => (
  <div>
    <p>Think about where you're going and pick a timeframe that works for you.</p>
    <p>Are you working towards:</p>
    <ul>
      <li>A down payment for a house in 5 years?</li>
      <li>A college fund when your child goes to university in 10 years?</li>
      <li>A comfortable retirement in 35 years?</li>
    </ul>
  </div>
);

class WalkthroughTimeframe extends React.Component<WalkthroughTimeframeProps> {
  public render () {
    return (
      <div className='walkthrough-steps'>
        <Why
          colour='green'
          illustration={timeframeIllustration}
          next={this.props.next}
          previous={this.props.previous}
          skip={this.props.skip}
          truncated={truncated()}
          expanded={expanded()}
        />
        <div className='walkthrough-how'>
          <div className='how-inner'>
            <div className='monthly-contribution-note'>
              <OnboardNote positionX='left' positionY='top'>
                <p>How long is it till you will need this money?</p>
              </OnboardNote>
            </div>
            <Timeframe
              duration={this.props.duration}
              setDuration={this.props.setDuration}
            />
            <button
              disabled={!this.props.next}
              onClick={this.props.next}
              className='button primary-button'
            >
              Confirm timeframe
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default WalkthroughTimeframe;
